import React from 'react'
import moment from 'moment'
import { hhmmss } from '../utils'

const Row = props => {
  
  const {
    name,
    audio_length,
    created_time,
    url
  } = props.item
  
  return (
    <div className='tr hover' onClick={() => props.handleClick(url)}>
      <div className='td'>
        <p>
          { moment(created_time).format('MM/DD/YY') }
        </p>
      </div>
      <div className='td'>
        <p>
          { name }
        </p>
      </div>
      <div className='td'>
        <p>
          { hhmmss(audio_length)}
        </p>
      </div>
    </div>
  )
}

export default Row